import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/store";
import axios from "axios";
import "iview/dist/styles/iview.css";
import ddlogin from "./components/dingtalk/dtLogin";
import "babel-polyfill";
import iView from "iview";
Vue.use(iView);

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.use(ddlogin);

import numberRoll from "@xc/numberroll";
Vue.use(numberRoll);

var APP_ID = "0v1RQvfpL4rrxEzKLpFvoXaD-gzGzoHsz";
var APP_KEY = "0wamBcaoj3PcFh37SKO3CYcz";
AV.init({
  appId: APP_ID,
  appKey: APP_KEY
});

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});

router.beforeEach((to, from, next) => {
  const agentid = window.localStorage.getItem("AGENTID");
  if (to.meta.requireAuth) {
    if (agentid) {
      next();
    } else {
      router.push({
        path: "/Login"
      });
    }
  } else {
    next();
  }
});



// WEBPACK FOOTER //
// ./src/main.js